import { registerLocaleData } from "@angular/common"
import { provideHttpClient, withFetch, withInterceptors } from "@angular/common/http"
import localeDe from "@angular/common/locales/de"
import {
  ApplicationConfig,
  Injectable,
  LOCALE_ID,
  provideBrowserGlobalErrorListeners,
} from "@angular/core"
import { DateAdapter, MAT_DATE_LOCALE } from "@angular/material/core"
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from "@angular/material/form-field"
import { Title } from "@angular/platform-browser"
import { provideAnimations } from "@angular/platform-browser/animations"
import { RouterStateSnapshot, TitleStrategy, provideRouter } from "@angular/router"

import { routes } from "./app.routes"
import { LocalDateAdapter } from "./core/adapters/local-date-adapter"
import { clerkAuthInterceptor } from "./core/interceptors/clerk-auth.interceptor"
import { errorNotificationInterceptor } from "./core/interceptors/error-notification.interceptor"

// Register German locale
registerLocaleData(localeDe)

@Injectable()
class AppTitleStrategy extends TitleStrategy {
  constructor(private readonly title: Title) {
    super()
  }

  override updateTitle(routerState: RouterStateSnapshot): void {
    const pageTitle = this.buildTitle(routerState)
    this.title.setTitle(pageTitle ? `${pageTitle} | Accounting` : "Accounting")
  }
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideHttpClient(
      withFetch(),
      withInterceptors([clerkAuthInterceptor, errorNotificationInterceptor]),
    ),
    provideAnimations(),
    { provide: TitleStrategy, useClass: AppTitleStrategy },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: "fill" },
    },
    { provide: LOCALE_ID, useValue: "de-DE" },
    { provide: MAT_DATE_LOCALE, useValue: "de-DE" },
    { provide: DateAdapter, useClass: LocalDateAdapter },
  ],
}
